// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    CatalogPage,
    CatalogPageResult,
    GetCatalogPageByPathApiParameter,
} from "@insite/client-framework/Services/CategoryService";
import {
    chain,
    DispatchCompleteLoadCatalogPage,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";

type Parameter = {
    path: string;
} & HasOnSuccess<CatalogPage>;
type Props = {
    apiParameter: GetCatalogPageByPathApiParameter;
    apiResult: CatalogPageResult;
};

type HandlerType = Handler<Parameter, Props>;

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = { ...props.parameter, numberoffeaturedproducts: 2 };
};

export const XngDispatchCompleteLoadCatalogPage: HandlerType = props => {
    props.dispatch({
        type: "Data/CatalogPages/CompleteLoadCatalogPage",
        model: props.apiResult.catalogPage,
        path: props.apiParameter.path,
    });
    if (props.apiResult.categoriesById) {
        // Xng change: solving issue of the count for child category
        let categoriesById;
        if (Object.keys(props.apiResult.categoriesById).length) {
            const categoryId = Object.keys(props.apiResult.categoriesById)[0];
            // GCG-565: fixing error shown on category page If user reach it from brand details page
            const categoryState = getCategoryState(props.getState(), categoryId);
            if (categoryState && categoryState.value) {
                categoriesById = {
                    [categoryId]: categoryState.value,
                };
            } else {
                return;
            }
        } else {
            categoriesById = props.apiResult.categoriesById;
        }
        props.dispatch({
            type: "Data/Categories/CompleteLoadCategoriesById",
            categoriesById
        });
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, DispatchCompleteLoadCatalogPage, XngDispatchCompleteLoadCatalogPage);
